export var WebSocketConnectionEvent;
(function (WebSocketConnectionEvent) {
    WebSocketConnectionEvent["Open"] = "open";
    WebSocketConnectionEvent["Send"] = "send";
    WebSocketConnectionEvent["Message"] = "message";
    WebSocketConnectionEvent["Closed"] = "closed";
})(WebSocketConnectionEvent || (WebSocketConnectionEvent = {}));
